<div class="sent-email-details">
    @if (email.error) {
        <mat-tab-group [mat-stretch-tabs]="false" [dynamicHeight]="true" animationDuration="0ms">
            <mat-tab [label]="'sentEmailDetails.detailsTab' | t"
                ><ng-container *ngTemplateOutlet="emailDetailsTemplate"></ng-container
            ></mat-tab>
            <mat-tab [label]="'sentEmailDetails.errorTab' | t">
                <div class="sent-email-error">
                    <cerrix-field-wrapper [label]="'sentEmailDetails.errorLabel' | t" type="secondary">
                        <div class="email-error-field" [attr.data-uiid]="dataUiid + '-error-field'">
                            {{ email.error }}
                        </div>
                    </cerrix-field-wrapper>
                </div>
            </mat-tab>
        </mat-tab-group>
    } @else {
        <ng-container *ngTemplateOutlet="emailDetailsTemplate"></ng-container>
    }
</div>

<ng-template #emailDetailsTemplate>
    <div class="sent-email-content">
        <cerrix-field-wrapper [label]="'sentEmailDetails.subjectLabel' | t" type="secondary">
            <div class="text-field" [attr.data-uiid]="dataUiid + '-subject'">
                {{ email.subject }}
            </div>
        </cerrix-field-wrapper>

        <cerrix-field-wrapper [label]="'sentEmailDetails.recipientLabel' | t" type="secondary">
            <mat-chip-set>
                <mat-chip
                    class="chip-field"
                    [attr.data-uiid]="dataUiid + '-recipient'"
                    disableRipple="true"
                >
                    {{ email.recipient }}
                </mat-chip>
            </mat-chip-set>
        </cerrix-field-wrapper>

        <cerrix-field-wrapper [label]="'sentEmailDetails.messageLabel' | t" type="secondary">
            <div
                class="html-field"
                [attr.data-uiid]="dataUiid + '-message'"
                [innerHTML]="embedHtml"
            ></div>
        </cerrix-field-wrapper>
    </div>
</ng-template>
